module.exports = __webpack_public_path__ + "static/media/helios_docs.f78d99d2.wav";